module.exports = __webpack_public_path__ + "static/media/ic_update.b7a1fd18.svg";